module.exports = __webpack_public_path__ + "img/flujos.2f0fd208.svg";